import { render, staticRenderFns } from "./PlanSelect.vue?vue&type=template&id=8ffdd188"
import script from "./PlanSelect.vue?vue&type=script&lang=js"
export * from "./PlanSelect.vue?vue&type=script&lang=js"
import style0 from "./PlanSelect.vue?vue&type=style&index=0&id=8ffdd188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports